module.exports = __webpack_public_path__ + "img/bing8.21d09433.png";